/**
 * Environment flags, read once at boot.
 *
 * @module config
 */

/** The visitor asked for less motion: every effect falls back to a still frame. */
export const REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/** No mouse: no custom cursor, no magnetic buttons, no hover-to-select. */
export const TOUCH = window.matchMedia('(hover: none)').matches;

/**
 * The loader already played in this visit: the head script of site/base
 * read it from the session before the first paint (ADR-0015).
 */
export const LOADER_SEEN = document.documentElement.classList.contains('is-loader-seen');

/**
 * A colour token of the stylesheet (base/_root.scss), so the palette lives
 * in one file.
 *
 * @param {string} name - Custom property name, without the dashes.
 * @param {string} fallback
 * @returns {string}
 */
export function cssColor(name, fallback) {
    const value = getComputedStyle(document.documentElement).getPropertyValue(`--${name}`).trim();
    return value || fallback;
}
